import React from 'react'

export const withMappedProps = (Component, mapFunc) => (props: Props) => {
	return <Component {...mapFunc(props)} />
}
